import config from '@plone/volto/registry';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

const LEGACY_SITE_PATTERN = /https?:\/\/[^"']*clinicasantjosep\.cat\/csj-1\//;
const LEGACY_HREF_PATTERN =
  /https?:\/\/(?:www\.)?clinicasantjosep\.cat(?:\/csj-1)?(\/[^"'?#]*)/i;

const rewriteLegacyHref = (url) => {
  const match = url.match(LEGACY_HREF_PATTERN);
  if (!match) {
    return url;
  }
  return flattenToAppURL(match[1]);
};

export const resolveRichTextHtml = (
  html,
  apiPath = config.settings.apiPath,
) => {
  if (!html) {
    return '';
  }

  let resolved = html.replace(
    /href="(https?:\/\/[^"]*clinicasantjosep\.cat[^"]*)"/gi,
    (match, url) => `href="${rewriteLegacyHref(url)}"`,
  );

  resolved = resolved.replace(
    /a href="([^"]*\.[^"]*)"/g,
    `a href="${apiPath}$1/download/file"`,
  );

  resolved = resolved.replace(
    /src="(?:\.\.\/)?resolveuid\/([^"]+)"/g,
    (_, uid) => `src="${flattenToAppURL(`/resolveuid/${uid}/@@images/image`)}"`,
  );

  resolved = resolved.replace(/src="([^"]+)"/g, (match, src) => {
    if (!LEGACY_SITE_PATTERN.test(src)) {
      return match;
    }
    return `src="${flattenToAppURL(src)}"`;
  });

  return resolved;
};
